<template>
    <div>
        <div style="display: flex">
            <a-form-item-rest v-if="props.isFiliale == 1">
                <a-input @change="
                    (res) => {
                        inputChange(res, 'filiale_full_name')
                    }
                " v-model:value="state.filiale_full_name" placeholder="总公司名称"></a-input>
            </a-form-item-rest>
            <a-form-item-rest v-if="props.isFiliale != 1">
                <a-input @change="
                    (res) => {
                        inputChange(res, 'name_division')
                    }
                " v-model:value="state.name_division" placeholder="名称区划"></a-input>
            </a-form-item-rest>
            <a-form-item-rest v-if="!state.no_word">
                <a-input @change="
                    (res) => {
                        inputChange(res, 'name_word_mark')
                    }
                " v-model:value="state.name_word_mark"
                    :placeholder="props.isFiliale == 1 ? '地域或字号:第一，湖南，长沙市' : '字号'"></a-input>
            </a-form-item-rest>
            <a-form-item-rest v-if="props.isFiliale != 1">
                <a-select allow-clear :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    optionLabelProp="label" popupClassName="principalName" :value="state.ondustry_representation_id"
                    show-search placeholder="行业表述" :default-active-first-option="false" :show-arrow="false"
                    :filter-option="false" :not-found-content="null" @search="handleSearch" @change="handleChange"
                    @blur="handleBlur" v-model:search-value="state.ondustry_keyword">
                    <a-select-option v-for="(item, index) in state.options" :key="index" :title="item.keyvalue"
                        :value="item.id" :label="item.keyname">
                        <div class="d-flex">
                            <span style="width: 160px">
                                {{ item.keyname }}
                            </span>
                            <!-- <span class="flex-1">
                <span class="top"> 置顶 </span>
              </span> -->
                            <span
                                style="width: 230px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px">
                                (行业：{{ item.keyvalue }}) </span>{{ item.push_system ?? '' }}
                        </div>
                    </a-select-option>
                </a-select>
            </a-form-item-rest>
            <a-form-item-rest>
                <a-select allow-clear :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                    :value="state.organizational_form" @change="
                        (res) => {
                            selectChange(res, 'organizational_form')
                        }
                    " placeholder="请选择">
                    <a-select-option v-for="(item, index) in state.organizationalFormList" :key="index" :value="item">
                        {{ item }}
                    </a-select-option>
                </a-select>
            </a-form-item-rest>
        </div>
        <div style="margin-top:10px">
            <a-form-item-rest>
                <a-form-item label="上级行业"
                    v-if="props.push_system == 2 && (props.principalType == 2 || (state.ondustry_representation_id && state.ondustry_representation_id >= 100000)) && props.business_type == 1"
                    :required="true">
                    <HangyeFour v-model:value="state.ondustry_representation_four" @change="triggerChange"></HangyeFour>
                </a-form-item>
            </a-form-item-rest>
        </div>
        <div>
            主体名称预览：
            <span style="color: red; cursor: pointer;font-size: 18px;" @click="
                (event) => {
                    handleNameClick(event)
                }
            ">{{ state.full_name }}</span><a @click="change_zihao_postion" class="ml-3x"
                v-if="props.principalType == 1 && state.name_division && state.name_word_mark && state.ondustry_representation && state.organizational_form">地域排序换位置</a>
            <span v-if="props.principalType == 2 || props.principalType == 3 || props.principalType == 4" class="ml-3x">
                <a-checkbox v-model:checked="state.no_postfix" @change="
                    (res) => {
                        checkboxChange('no_postfix')
                    }
                " v-if="props.business_type != 1">无后缀</a-checkbox>
            </span>
            <span v-if="props.principalType == 1 && props.isFiliale == 1" class="ml-3x">
                <a-checkbox v-model:checked="state.no_word" @change="
                    (res) => {
                        checkboxChange('no_word')
                    }
                ">无字号</a-checkbox>
            </span>
            <span><a class="ml-3x" @click="getHangye()" v-if="props.push_system == 1">获取行业</a></span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { reactive, watch, onUnmounted, nextTick, onMounted } from 'vue'
const emit = defineEmits(['update:value'])
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
import { message } from 'ant-design-vue'
import { trimAll } from '@/utils/util'
import { getOrganizationalForm } from '../../customerFn'
import HangyeFour from './HangyeFour.vue'
let timer: any = null
const props = defineProps({
    value: {
        type: Object
    },
    principalType: {
        type: Number
    },
    company_type_id: {
        type: Number
    },
    business_type: {
        type: Number
    },
    isFiliale: {
        type: Number
    },
    is_heming: {
        type: Number,
        default: 2
    },
    push_system: {
        type: [Number, null],
        default: null
    }
})
interface IState {
    options: any[]
    name_division: string
    full_name: string
    name_division_position: number
    filiale_full_name: string
    name_word_mark: string
    ondustry_representation: string | undefined
    organizational_form: string | null
    ondustry_representation_type: number | null
    ondustry_representation_id: number | null
    ondustry_representation_four: string | undefined
    no_postfix: boolean
    no_word: boolean
    isFirst: boolean
    organizationalFormList: any[]
    ondustry_keyword: string
    hangyeInterval: any
}
const state = reactive<IState>({
    options: [],
    name_division: '',
    full_name: '',
    name_division_position: 0,
    filiale_full_name: '',
    name_word_mark: '',
    ondustry_representation: undefined,
    organizational_form: '',
    ondustry_representation_type: null,
    ondustry_representation_id: null,
    ondustry_representation_four: undefined,
    no_postfix: false,
    no_word: false,
    isFirst: true,
    organizationalFormList: [],// 组织形式
    ondustry_keyword: '',
    hangyeInterval: {
        timer: null,
        time: 5000
    }
})

// ============ 把 triggerChange 定义在所有 watch 之前 ============
const triggerChange = () => {
    let full_name = ''
    if (props.isFiliale == 1) {
        if (state.no_word) {
            //分公司可以没有字号
            state.name_word_mark = ''
        }
        full_name = `${state.filiale_full_name}${state.name_word_mark}${state.organizational_form}`
    } else {
        //公司需要根据位置
        if (state.name_division_position == 0) {
            full_name = state.name_division + state.name_word_mark + state.ondustry_representation + state.organizational_form
        } else if (state.name_division_position == 1) {
            full_name = state.name_word_mark + '（' + state.name_division + '）' + state.ondustry_representation + state.organizational_form
        } else {
            full_name = state.name_word_mark + state.ondustry_representation + '（' + state.name_division + '）' + state.organizational_form
        }
        //补上括弧
        if (!state.no_postfix) {
            if (props.principalType == 2) {
                full_name = full_name + '（个体工商户）'
            } else if (props.principalType == 3) {
                full_name = full_name + (props.push_system == 2 ? '（个人独资企业）' : '（个人独资）')
            } else if (props.principalType == 4) {
                if (props.company_type_id == 14) {
                    full_name = full_name + '（有限合伙）'
                } else if (props.company_type_id == 15) {
                    full_name = full_name + '（有限合伙分支机构）'
                } else if (props.company_type_id == 16) {
                    full_name = full_name + '（普通合伙）'
                } else if (props.company_type_id == 17) {
                    full_name = full_name + '（普通合伙分支机构）'
                } else if (props.company_type_id == 18) {
                    full_name = full_name + '（特殊普通合伙）'
                } else if (props.company_type_id == 19) {
                    full_name = full_name + '（特殊普通合伙分支机构）'
                }
            }
        }
    }
    emit('update:value', {
        name_division: state.name_division,
        filiale_full_name: state.filiale_full_name,
        name_word_mark: state.name_word_mark,
        ondustry_representation: state.ondustry_representation,
        organizational_form: state.organizational_form,
        ondustry_representation_type: state.ondustry_representation_type,
        ondustry_representation_id: state.ondustry_representation_id,
        ondustry_representation_four: state.ondustry_representation_four,
        name_division_position: state.name_division_position,
        no_postfix: state.no_postfix ? 1 : 2,
        no_word: state.no_word ? 1 : 2,
        full_name: full_name
    })
}
// ============================================================

onUnmounted(() => {
    clearInterval(state.hangyeInterval.timer)
})
//统一监听，因为单个监听的顺序会混乱
watch(
    [
        () => props.value,
        () => props.principalType,
        () => props.push_system,
        () => props.isFiliale,
        () => props.company_type_id,
    ],
    (newValues, oldValues) => {
        // 处理逻辑
        const [value, principalType, push_system, isFiliale, company_type_id] = newValues;
        const [oldValue, oldPrincipalType, oldPushSystem, oldIsFiliale, oldCompanyTypeId] = oldValues;

        const isValueChanged = JSON.stringify(value) !== JSON.stringify(oldValue);
        if (!isValueChanged) {//如果值没有变，才执行;也就是单独切换其他选项时候才执行
            let needChange = false
            //如果改变了主体类型，或推送系统，则清空行业
            if (principalType != oldPrincipalType || push_system != oldPushSystem) {
                state.ondustry_keyword = ''
                state.ondustry_representation = ''
                state.ondustry_representation_type = null
                state.ondustry_representation_id = null
                state.ondustry_representation_four = ''
                state.options = []
                needChange = true
            }
            //如果改变了是否分公司，主体类型，推送系统，则需要改变后缀的选项
            if (isFiliale != oldIsFiliale || principalType != oldPrincipalType || push_system != oldPushSystem) {
                if (props.principalType) {
                    //更新后缀的选项
                    state.organizationalFormList = getOrganizationalForm(props.principalType, props.isFiliale, props.push_system) || []
                    if (props.principalType == 1 && state.organizationalFormList.length > 0) {
                        state.organizational_form = state.organizationalFormList[0]
                    } else {
                        state.organizational_form = null
                    }
                    needChange = true
                }
            }
            //如果改变了行业小类，需要重新计算名称
            if (company_type_id != oldCompanyTypeId) {
                needChange = true
            }
            if (needChange) {
                triggerChange()
            }
        } else {
            //entityNameToRegister 名称对象变了，可能是初始化，也可能是emit后引起的变化
            if (value) {
                state.name_division = value.name_division || ''
                state.filiale_full_name = value.filiale_full_name || null
                state.name_word_mark = value.name_word_mark || ''
                state.ondustry_representation = value.ondustry_representation || ''
                state.ondustry_representation_type = value.ondustry_representation_type || null
                state.ondustry_representation_id = value.ondustry_representation_id || null
                if (state.ondustry_representation && value.ondustry_representation_id == 0) {
                    state.ondustry_representation_id = 0 //如果选了行业，可能id真的为0，不是null
                }
                state.ondustry_representation_four = value.ondustry_representation_four || ''
                state.organizational_form = value.organizational_form || ''
                state.name_division_position = value.name_division_position || 0
                state.no_postfix = value.no_postfix == 1 ? true : false
                state.no_word = value.no_word == 1 ? true : false
                state.full_name = value.full_name || ''

                if (value.ondustry_representation) {
                    if (!state.isFirst) return
                    state.isFirst = false
                    handleSearch(value.ondustry_representation)
                }
            }
        }
    },
    { deep: true, immediate: true }
);

const change_zihao_postion = () => {
    state.name_division_position += 1
    if (state.name_division_position == 3) {
        state.name_division_position = 0
    }
    triggerChange()
}

const inputChange = (value, type) => {
    if (type == 'name_division') {
        value.target.value = value.target.value.replace('巿', '市')
        if (props.push_system == 2) {
            //如果字号里面存在省
            if (value.target.value.indexOf('省') != -1) {
                value.target.value = value.target.value.replace('省', '')
                message.error('冠省名，只能写“陕西”，不能写“陕西省”，已自动删除“省”字')
            }
        }
    } else if (type == 'filiale_full_name') {
        value.target.value = value.target.value.replaceAll('(', '（').replaceAll(')', '）')
    }
    value.target.value = trimAll(value.target.value)
    state[type] = value.target.value
    triggerChange()
}

const selectChange = (value, type) => {
    if (props.isFiliale == 1) {
        state.name_division = ''
        state.ondustry_representation = ''
    } else {
        state.filiale_full_name = ''
    }
    state[type] = value
    triggerChange()
}

const checkboxChange = (type) => {
    triggerChange()
}

const handleSearch = (val: string) => {
    if (props.business_type != 1 || props.is_heming == 1) {
        state.options = [
            {
                id: val,
                keyname: val,
                keyvalue: val
            }
        ]
        return
    }
    clearTimeout(timer)
    if (val == '') {
        state.options = []
        return
    }
    // 必须中文
    var reg = /^[\u4E00-\u9FA5]+$/
    if (!reg.test(val)) {
        return
    }
    if (val.includes('有限公司')) {
        val = val.replace('有限公司', '')
    } else if (val.includes('有限责任公司')) {
        val = val.replace('有限责任公司', '')
    }
    state.ondustry_keyword = val
    timer = setTimeout(() => {
        if (props.principalType == 1 || props.principalType == 3 || props.principalType == 4) {
            let requestParam = {
                url: '/admin/v1/getCompanyStep?keys=' + val + '&push_system=' + props.push_system,
                method: 'get'
            }
            baseService(requestParam)
                .then((res) => {
                    if (!res.data.some((res) => res.keyname.indexOf(val) !== -1)) {
                        //西安如果没有这个行业，可以手动添加
                        if (props.push_system == 2) {
                            const randomNum = state.ondustry_representation_id && state.ondustry_representation_id >= 100000 ? state.ondustry_representation_id + 1 : 100000;
                            res.data.unshift({
                                keyname: val,
                                id: randomNum,
                                keyvalue: '请点击选择行业'
                            })
                        }
                    }
                    state.options = res.data
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        } else {
            let requestParam = {
                url: '/admin/v1/getIndividualStep?keys=' + val + '&push_system=' + props.push_system,
                method: 'get'
            }
            baseService(requestParam)
                .then((res: any) => {
                    if (!res.data.some((res) => res.keyname === val)) {
                        //西安如果没有这个行业，可以手动添加
                        if (props.push_system == 2) {
                            const randomNum = state.ondustry_representation_id && state.ondustry_representation_id >= 100000 ? state.ondustry_representation_id + 1 : 100000;
                            res.data.unshift({
                                keyname: val,
                                id: randomNum,
                                keyvalue: '请点击选择行业'
                            })
                        }
                    }
                    if (res.data.length == 0) {
                        message.error(res.msg)
                    } else {
                        state.options = res.data
                    }
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        }
    }, 500)
}

// 复制名称
const handleNameClick = (event) => {
    var input = document.createElement('input')
    //将input的值设置为需要复制的内容
    input.value = event.target.innerHTML
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功，尝试双击有惊喜！')
    //移除input标签
    document.body.removeChild(input)
}

const handleChange = (val, obj) => {
    // if (obj.value >= 100000) {
    //     //西安手动添加的行业
    // } else {
    //     state.ondustry_representation_four = ''
    // }
    state.ondustry_representation = obj.label
    state.ondustry_representation_type = obj.title
    state.ondustry_representation_id = obj.value
    triggerChange()
}

const handleBlur = () => {
    // 失焦后延时清空，给下拉选项选择留出时间
    setTimeout(() => {
        state.ondustry_keyword = state.ondustry_representation + ''
    }, 150)
}

defineExpose({
    inputChange,
    state
})

//去工商局重新获取行业
const getHangye = () => {
    if (!state.ondustry_keyword) {
        message.error('请先输入行业表述')
        return
    }
    const hide = message.loading({
        content: '查询中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: '/admin/v1/getHangyeStep',
        method: 'post',
        data: { indus: state.ondustry_keyword, main_type: props.principalType }
    }
    baseServicePlus(requestParam, state.hangyeInterval)
        .then((res: any) => {
            message.success(res.msg)
            //重新搜索一下
            handleSearch(state.ondustry_keyword)
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
}
</script>

<style lang="less" scoped>
.d-flex {
    justify-content: space-between;
}

.top {
    color: #1890ff;
    display: none;
    cursor: pointer;
}

.d-flex:hover {
    .top {
        display: block;
    }
}
</style>
<style lang="less">
.principalName {
    width: 500px !important;
    margin-left: -70px !important;
}
</style>
